import React from "react";
import { NavLink } from "react-router-dom";
import logo  from "../Assests/logo.png"


function Navbar() {
  return (
    <nav className="nav">
      <div className="nav__brand">
       <img
          src={logo}
          alt="Logo"
          style={{
            width: "100px",
            height: "100px",
            objectFit: "contain",
            marginRight: "8px",
            verticalAlign: "middle"
          }}
        />

        {/* <div className="nav__eyebrow">Sri Lankan Harvest</div> */}

        {/* <Link to="/" className="nav__logo">
          RAJARATA SAHAL MILLS
        </Link>

        <p className="nav__tagline">
          Pure, freshly milled grains from the heart of Sri Lanka
        </p> */}
      </div>
      <div className="nav__links">
        <NavLink to="/" className={({ isActive }) => `nav__link ${isActive ? "is-active" : ""}`}>
          Home
        </NavLink>
        <NavLink to="/products" className={({ isActive }) => `nav__link ${isActive ? "is-active" : ""}`}>
          Products
        </NavLink>
        <NavLink to="/about" className={({ isActive }) => `nav__link ${isActive ? "is-active" : ""}`}>
          About
        </NavLink>
        <NavLink to="/contact" className={({ isActive }) => `nav__link ${isActive ? "is-active" : ""}`}>
          Contact
        </NavLink>
      </div>
      <a className="nav__cta" href="tel:+941234567">
        Contact US
      </a>
    </nav>
  );
}

export default Navbar;
